(function() {
    'use strict';
    
a3_cabin_reports.factory('ACSupplyFactory', ACSupplyFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ACSupplyFactory
    * @description 
    *   Manage ACSupplies.
    * @ngInject
    */
function ACSupplyFactory(GenericValuesFactory) {
        
        /**
         * Initialiaze ACSupply object 
         * @memberof ACSupplyFactory
         */
		function ACSupply() {
			this.Code = null;
		}
			
		var callback=ACSupply;
		var type ='acSupplies';
			
		var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			toObjectList : toObjectList,
			getACSuppliesFromStorage : getACSuppliesFromStorage,
			getACSuppliesFromStorageAsStrings : getACSuppliesFromStorageAsStrings,
			setACSuppliesToStorage : setACSuppliesToStorage
		}
	 
        /**
         * Extend given ACSupply object 
         * @memberof ACSupplyFactory
         * @param {object} obj The ACSupply object that will be extended
         * @returns {object} ACSupply
         */
		function fromObject(obj) {
			return GenericValuesFactory.fromObject(obj,callback);
		}

        /**
         * Extend given ACSupply object list
         * @memberof ACSupplyFactory
         * @param {array} objList The list of ACSupply objects that will be extended
         * @returns {object} ACSupplies
         */
		function fromObjectList(objList) {
			return GenericValuesFactory.fromObjectList(objList,callback);
		}

        /**
         * Get all the ACSupply's Code from given list
         * @memberof ACSupplyFactory
         * @param {array} objectList An object list
         * @returns {array} ACSupplies
         */
		function toObjectList(objList) {
			return GenericValuesFactory.objList(objList);
		}

        /**
         * Get all the ACSupply objects
         * @memberof ACSupplyFactory
         * @returns {array} ACSupplies
         */
		function getACSuppliesFromStorage() {
			return GenericValuesFactory.getValuesFromStorage(callback,type);
		}

         /**
         * Get all the ACSupply's codes from local storage
         * @memberof ACSupplyFactory
         * @returns {array} ACSupplies
         */
		function getACSuppliesFromStorageAsStrings() {
			return GenericValuesFactory.getValuesFromStorageAsStrings(callback,type);
		}

        /**
         * Set all the ACSupplies
         * @memberof ACSupplyFactory
         * @param {array} objects A list of ACSupplies.
         */
		function setACSuppliesToStorage(objList) {
			GenericValuesFactory.setValuesToStorage(objList,type);
		}

		return service;
	}

})();
